// @ts-strict-ignore
import { FsCore } from '../../types/fs-core'

const productTablesState = (s: FsCore.State) => s.productTables

const eligibilityResultsState = (s: FsCore.State) => productTablesState(s).eligibilityResults || []

export const getEligibilityResults = (s: FsCore.State) => eligibilityResultsState(s)
